import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RightBridgeApiService } from './right-bridge-api.service';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorReportingService } from './error-reporting.service';
import { Global } from '../models/global.model';
import { ApiResponse } from '../models/general-models';

@Injectable()
export class AppGlobalsService {
  private rbs = inject(RightBridgeApiService);
  private errSvc = inject(ErrorReportingService);

  resolve(route: ActivatedRouteSnapshot): Observable<ApiResponse<Global>> {
    const globals = this.rbs.getGlobals(null, null, 'rb', true).pipe(
      map(res => {
        return res;
      }),
      catchError((error: any) => {
        return this.errSvc.handleError(error);
      })
    );
    return globals;
  }
}
